'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Data = require('../../../../helpers/Data');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _reactDimensions = require('react-dimensions');

var _reactDimensions2 = _interopRequireDefault(_reactDimensions);

var _EventsBar = require('./EventsBar');

var _EventsBar2 = _interopRequireDefault(_EventsBar);

var _helpers = require('../helpers');

var _Constants = require('../Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Decorators


// Components


// Helpers and constansts


/**
 * Default method to convert a date to a string label
 * @param {string} date The string representation of a date
 * @return {string} The formatted date string
 */
var defaultGetLabel = function defaultGetLabel(date, index) {
  return new Date(date).toDateString().substring(4);
};

/*
 * This is the Horizontal Timeline. This component expects an array of dates
 * just as strings (e.g. 1993-01-01) and layes them horizontaly on the the screen
 * also expects a callback which is activated when that particular index is
 * clicked passing that index along
 */

var HorizontalTimeline = function (_React$Component) {
  _inherits(HorizontalTimeline, _React$Component);

  function HorizontalTimeline() {
    _classCallCheck(this, HorizontalTimeline);

    return _possibleConstructorReturn(this, (HorizontalTimeline.__proto__ || Object.getPrototypeOf(HorizontalTimeline)).apply(this, arguments));
  }

  _createClass(HorizontalTimeline, [{
    key: 'trimFunction',
    value: function trimFunction(titulo) {
      return titulo.length > 40 ? titulo.substring(0, 37).trim() + "..." : titulo;
    }
  }, {
    key: 'getLabelContent',
    value: function getLabelContent(index) {
      return '<div>' + this.trimFunction(this.props.tltitles[index]) + '</div> <b>' + (0, _Data.formatLongToDate)(this.props.values[index]) + '</b>';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = this.props;

      if (!props.containerWidth) {
        //As long as we do not know the width of our container, do not render anything!
        return false;
      }

      // Convert the date strings to actual date objects
      var dates = props.values.map(function (value) {
        return new Date(value);
      });
      // Calculate the distances for all events
      var distances = (0, _helpers.cummulativeSeperation)(dates, props.labelWidth, props.minEventPadding, props.maxEventPadding, props.linePadding);

      // Convert the distances and dates to events
      var events = distances.map(function (distance, index) {
        return {
          distance: distance,
          label: _this2.getLabelContent(index),
          date: props.values[index] + ""
        };
      });

      var visibleWidth = this.props.containerWidth - 80;

      var totalWidth = Math.max(events[events.length - 1].distance + this.props.linePadding, visibleWidth);

      var barPaddingRight = 0;
      var barPaddingLeft = 0;
      if (!this.props.isOpenEnding) {
        barPaddingRight = totalWidth - events[events.length - 1].distance;
      }
      if (!this.props.isOpenBeginning) {
        barPaddingLeft = events[0].distance;
      }

      return _react2.default.createElement(_EventsBar2.default, {
        width: props.containerWidth,
        height: props.containerHeight,
        events: events,
        isTouchEnabled: props.isTouchEnabled,
        totalWidth: totalWidth,
        visibleWidth: visibleWidth,
        index: props.index,
        styles: props.styles,
        indexClick: props.indexClick,
        labelWidth: props.labelWidth,
        fillingMotion: props.fillingMotion,
        barPaddingRight: barPaddingRight,
        barPaddingLeft: barPaddingLeft,
        todayIndex: props.todayIndex
      });
    }
  }]);

  return HorizontalTimeline;
}(_react2.default.Component);

/**
 * The expected properties from the parent
 * @type {Object}
 */


HorizontalTimeline.propTypes = {
  // --- EVENTS ---
  // Selected index
  index: _propTypes2.default.number,
  // Array containing the sorted date strings
  values: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
  // Function that takes the index of the array as argument
  indexClick: _propTypes2.default.func,
  // Function to calculate the label based on the date string
  getLabel: _propTypes2.default.func,
  // --- POSITIONING ---
  // the minimum padding between events
  minEventPadding: _propTypes2.default.number,
  // The maximum padding between events
  maxEventPadding: _propTypes2.default.number,
  // Padding at the front and back of the line
  linePadding: _propTypes2.default.number,
  // The width of the label
  labelWidth: _propTypes2.default.number,
  // --- STYLING ---
  styles: _propTypes2.default.object,
  fillingMotion: _propTypes2.default.object,
  slidingMotion: _propTypes2.default.object,
  isOpenEnding: _propTypes2.default.bool,
  isOpenBeginning: _propTypes2.default.bool,
  // --- INTERACTION ---
  isTouchEnabled: _propTypes2.default.bool,
  isKeyboardEnabled: _propTypes2.default.bool
};

/**
 * The values that the properties will take if they are not provided
 * by the user.
 * @type {Object}
 */
HorizontalTimeline.defaultProps = {
  // --- EVENTS ---
  getLabel: defaultGetLabel,
  // --- POSITIONING ---
  minEventPadding: _Constants2.default.MIN_EVENT_PADDING,
  maxEventPadding: _Constants2.default.MAX_EVENT_PADDING,
  linePadding: _Constants2.default.TIMELINE_PADDING,
  labelWidth: _Constants2.default.DATE_WIDTH,
  // --- STYLING ---
  styles: {
    outline: '#dfdfdf',
    background: '#f8f8f8',
    foreground: '#7b9d6f'
  },
  fillingMotion: {
    stiffness: 150,
    damping: 25
  },
  slidingMotion: {
    stiffness: 150,
    damping: 25
  },
  isOpenEnding: true,
  isOpenBeginning: true,
  // --- INTERACTION ---
  isTouchEnabled: true,
  isKeyboardEnabled: true
};

exports.default = (0, _radium2.default)((0, _reactDimensions2.default)({ elementResize: true })(HorizontalTimeline));


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/timeline/react-horizontal-timeline/Components/HorizontalTimeline.js
// module id = 1149
// module chunks = 0